import client from "~/apis/client"

export function fetchCleaners() {
  return client.get("/cleaners")
}

export function createCleaner(cleaner) {
  return client.post("/cleaners", { cleaner })
}

export function updateCleaner(id, cleaner) {
  return client.patch(`/cleaners/${id}`, { cleaner })
}

export function rotateCleanerToken(id) {
  return client.post(`/cleaners/${id}/rotate_token`)
}
